import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { Navigate, useParams } from "react-router";

import ListBimClassRevisions from "./ListBimClassRevisions.graphql";
import { TAXONOMY_BASE } from "../../../../constants";

/**
 * Was a data-router `loader`. The console mounts features with <Routes>, which
 * has no loader support, so the redirect happens after the query resolves.
 */
export default function RedirectToRevision() {
    const { bimClassID } = useParams();

    const listBimClassRevisions = useQuery(
        gql(ListBimClassRevisions),
        {
            variables: {
                id: bimClassID,
            },
        },
    );

    if (listBimClassRevisions.loading) return "loading";
    if (listBimClassRevisions.error) return "error";

    const revisions = listBimClassRevisions.data?.bimClasses ?? [];
    const target = revisions.find((revision) => revision.metadata.tags.includes("public"))
        ?? revisions.find((revision) => revision.metadata.tags.includes("latest"));

    if (!target) return <Navigate replace to={ `${ TAXONOMY_BASE }/BimClasses` } />;

    return <Navigate replace to={ `${ TAXONOMY_BASE }/BimClasses/${ bimClassID }/revisions/${ target.revisionID }` } />;
}
